export default __webpack_public_path__ + "bf28b0d.png";